// function for setting cell color based on percentage //
import React from "react"
import tinycolor from 'tinycolor2'

const Wins = ({ wins }) => {

    var parsedWins = parseFloat(wins).toFixed(1)

    const zero_color = '#ffffff'
    const max_color = '#a1c3ff'

    return (
        <div style={{
            background : tinycolor.mix(zero_color, max_color, 100 * parsedWins / 17),
            height: '100%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            {parsedWins}
        </div>
    )

    
}

export default Wins